"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

var _bitcoinjsLib = require("bitcoinjs-lib");

var _oipdApi = require("../oipd-api");

var _modules = require("../../modules");

var _records = require("../../modules/records");

var _edit = require("../../modules/records/edit");

var _wallets = require("../../modules/wallets");

var _FLOTransaction = require("../../modules/flo/FLOTransaction");

var _config = require("../../config");
/**
 * Class to publish, register, edit, transfer, and deactivate OIP Records
 */


var OIP = /*#__PURE__*/function () {
  /**
   * ##### Example
   * ```javascript
   * import {OIP} from 'js-oip'
   *
   * let wif = "cRVa9rNx5N1YKBw8PhavegJPFCiYCfC4n8cYmdc3X1Y6TyFZGG4B"
   * let oip = new OIP(wif, "testnet")
   * ```
   * @param {String} wif - private key in Wallet Import Format (WIF) see: {@link https://en.bitcoin.it/wiki/Wallet_import_format}
   * @param {String} [network="mainnet"] - Use "testnet" for mainnet
   * @param {Object} [options] - Options to for the OIP class
   * @param {Object} [options.publicAddress] - Explicitly define a public address for the passed WIF
   * @param {Object} [options.oipdURL] - The OIP daemon API url to use when looking up the Latest Record in oip.edit()
   * @param {Object} [options.rpc] - By default, OIP uses a connection to a web explorer to publish Records, you can however use a connection to an RPC wallet instead by passing an object into this option
   * @param {Object} [options.rpc.host] - The Hostname for the RPC wallet connection
   * @param {Object} [options.rpc.port] - The Port for the RPC wallet connection
   * @param {Object} [options.rpc.username] - The Username for the RPC wallet connection
   * @param {Object} [options.rpc.password] - The Password for the RPC wallet connection
   */
  function OIP(wif, network, options) {
    _classCallCheck(this, OIP);

    this.options = options || {};
    this.options.wif = wif;
    this.options.network = network; // If public address is not defined, calculate it using bitcoin-js (used by RPC-Wallet)

    if (!this.options.publicAddress) {
      var tmpNetwork = _config.floMainnet;

      if (network === 'testnet') {
        tmpNetwork = _config.floTestnet;
      }

      if (network === 'regtest') {
        tmpNetwork = _config.floRegtest;
      }

      var myECPair = _bitcoinjsLib.ECPair.fromWIF(this.options.wif, tmpNetwork.network);

      this.options.publicAddress = _bitcoinjsLib.payments.p2pkh({
        pubkey: myECPair.publicKey,
        network: tmpNetwork.network
      }).address;
    }

    if (this.options.rpc) {
      this.wallet = new _wallets.RPCWallet(this.options);
      this.walletInitialized = false;
    } else {
      this.wallet = new _wallets.ExplorerWallet(this.options);
      this.walletInitialized = true;
    }

    this.oipdAPI = new _oipdApi.DaemonApi(this.options.oipdURL);
  }
  /**
   * Sign an OIP Record (if unsigned), and verify it's signature
   * @param  {OIPRecord} record - The record you want to make sure is signed
   */


  _createClass(OIP, [{
    key: "signRecord",
    value: function () {
      var _signRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(record) {
        var _yield$record$signSel, success, error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!record.getSignature() || record.getSignature() === '')) {
                  _context.next = 11;
                  break;
                }

                // Set the publisher address
                record.setPubAddress(this.options.publicAddress); // Check if a timestamp is set, and if not, set it to the current date (in ms time)

                if (!record.getTimestamp()) {
                  record.setTimestamp(Date.now());
                } // Attempt the signing of the Record


                _context.next = 5;
                return record.signSelf(this.wallet.signMessage.bind(this.wallet));

              case 5:
                _yield$record$signSel = _context.sent;
                success = _yield$record$signSel.success;
                error = _yield$record$signSel.error;

                if (success) {
                  _context.next = 11;
                  break;
                }

                // If there was an error, log the stack, and then return the error.
                console.log(error.stack);
                throw new Error("Failed to sign record: ".concat(error));

              case 11:
                if (record.hasValidSignature()) {
                  _context.next = 13;
                  break;
                }

                throw new Error("Invalid signature");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signRecord(_x) {
        return _signRecord.apply(this, arguments);
      }

      return signRecord;
    }()
    /**
     * Broadcast an OIP Record
     * @param {OIPRecord} record - Any Object whos class extends OIPRecord (Artifact, Publisher, Platform, Retailer, Influencer, EditRecord, etc)
     * @param {String} methodType - The method you are wanting to perform, i.e. `publish`, `edit`, `deactivate`, `transfer` etc
     * @return {Promise<Object>} response - An object that contains a var for `success`, the `record` that was published, and the `editRecord` if it is an edit
     * let oip = new OIP(wif, "testnet")
     * let artifact = new Artifact()
     * let result = await oip.broadcastRecord(artifact, 'publish')
     */

  }, {
    key: "broadcastRecord",
    value: function () {
      var _broadcastRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(record, methodType) {
        var _record$isValid, success, error, broadcastString, txids, txid, response, patchedRecord;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (record instanceof _records.OIPRecord) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Record must be an instanceof OIPRecord");

              case 2:
                if (this.walletInitialized) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 5;
                return this.wallet.initialize();

              case 5:
                this.walletInitialized = true;

              case 6:
                _context2.prev = 6;
                _context2.next = 9;
                return this.signRecord(record);

              case 9:
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);
                return _context2.abrupt("return", {
                  success: false,
                  error: "Error while Signing Record: ".concat(_context2.t0)
                });

              case 14:
                // Make sure the Record is valid
                _record$isValid = record.isValid(), success = _record$isValid.success, error = _record$isValid.error;

                if (success) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt("return", {
                  success: false,
                  error: "Invalid record: ".concat(error)
                });

              case 17:
                // Create the data we are broadcasting to the chain
                broadcastString = record.serialize(methodType); // Array to store txids

                txids = []; // Check if we need to publish it using Multiparts, or if it will fit into a single transaction

                if (!(broadcastString.length > _FLOTransaction.FLODATA_MAX_LEN)) {
                  _context2.next = 31;
                  break;
                }

                _context2.prev = 20;
                _context2.next = 23;
                return this.publishMultiparts(broadcastString);

              case 23:
                txids = _context2.sent;
                _context2.next = 29;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t1 = _context2["catch"](20);
                return _context2.abrupt("return", {
                  success: false,
                  error: "Failed to publish multiparts: ".concat(_context2.t1)
                });

              case 29:
                _context2.next = 41;
                break;

              case 31:
                _context2.prev = 31;
                _context2.next = 34;
                return this.wallet.sendDataToChain(broadcastString);

              case 34:
                txid = _context2.sent;
                txids = [txid];
                _context2.next = 41;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t2 = _context2["catch"](31);
                return _context2.abrupt("return", {
                  success: false,
                  error: "Failed to broadcast message: ".concat(_context2.t2)
                });

              case 41:
                // Set the txid to the Record
                record.setTXID(txids[0]); // Grab the data we need and bundle it for returning

                response = {
                  success: true,
                  txids: txids,
                  record: record
                }; // If we are an edit record, also return the edit record :)

                if (record instanceof _edit.EditRecord) {
                  // Grab the patched record to return
                  patchedRecord = record.getPatchedRecord(); // Set the edit version to the EditRecord txid

                  patchedRecord.setEditVersion(txids[0]); // Move EditRecord and set patchedRecord

                  response.record = patchedRecord;
                  response.editRecord = record;
                } // Return our built response


                return _context2.abrupt("return", response);

              case 45:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 11], [20, 26], [31, 38]]);
      }));

      function broadcastRecord(_x2, _x3) {
        return _broadcastRecord.apply(this, arguments);
      }

      return broadcastRecord;
    }()
    /**
     * Publish OIP Records
     * @param {OIPRecord} record - an Artifact, Publisher, Platform, Retailer, or Influencer
     * @return {Promise<Object>} response - An object that contains a var for `success`, the `record` that was published
     * let oip = new OIP(wif, "testnet")
     * let artifact = new Artifact()
     * let result = await oip.publish(artifact)
     */

  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(record) {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.broadcastRecord(record, 'publish');

              case 2:
                res = _context3.sent;
                return _context3.abrupt("return", res);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function publish(_x4) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }() // async register(record) {
    // } //ToDo

    /**
     * Publish an Edit for a Record
     * @param  {OIPRecord} editedRecord - The new version of the Record
     * @return {Promise<Object>} response - An object that contains a var for `success`, the `record` that was published, and the `editRecord`
     * @Example
     * let oip = new OIP(wif, "testnet")
     * let record = new Artifact(previousArtifactJSON)
     * record.setTitle('new title')
     * let result = await oip.edit(record)
     */

  }, {
    key: "edit",
    value: function () {
      var _edit2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(editedRecord) {
        var original, _yield$this$oipdAPI$g, success, record, error, edit, res;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.oipdAPI.getRecord(editedRecord.getOriginalTXID());

              case 3:
                _yield$this$oipdAPI$g = _context4.sent;
                success = _yield$this$oipdAPI$g.success;
                record = _yield$this$oipdAPI$g.record;
                error = _yield$this$oipdAPI$g.error;

                if (!success) {
                  _context4.next = 11;
                  break;
                }

                original = record;
                _context4.next = 12;
                break;

              case 11:
                return _context4.abrupt("return", {
                  success: false,
                  error: "Unable to load Original Record from OIP daemon: ".concat(error)
                });

              case 12:
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", {
                  success: false,
                  error: "Error while requesting Original Record from OIP daemon: ".concat(_context4.t0)
                });

              case 17:
                if (original) {
                  _context4.next = 19;
                  break;
                }

                return _context4.abrupt("return", {
                  success: false,
                  error: "A Record with the txid ".concat(editedRecord.getOriginalTXID(), " was not found in OIP daemon! Please make sure you have set 'options.oipdURL' to your OIP daemon server!")
                });

              case 19:
                // Set the Publisher Address before we sign
                editedRecord.setPubAddress(this.options.publicAddress); // Check if a timestamp is set, and if not, set it to the current date (in ms time)

                if (!editedRecord.getTimestamp()) {
                  editedRecord.setTimestamp(Date.now());
                } // Create an Edit Record from the Original and Edited


                edit = new _edit.EditRecord(undefined, original, editedRecord); // Publish to chain

                _context4.next = 24;
                return this.broadcastRecord(edit, 'edit');

              case 24:
                res = _context4.sent;
                return _context4.abrupt("return", res);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 14]]);
      }));

      function edit(_x5) {
        return _edit2.apply(this, arguments);
      }

      return edit;
    }() // async transfer(record) {
    // } //ToDO
    // async deactivate(record) {
    // } //ToDo

    /**
     * Publish data that exceeds the maximum floData length in multiple parts
     * @param {string} data - The data you wish to publish
     * @return {Promise<Array.<String>>} txids - An array of transaction IDs
     * @example
     * let oip = new OIP(wif, "testnet")
     * let txArray = await oip.publishMultiparts(superLongStringData)
     * //For multipart publishing, use oip.publish() instead. Will auto redirect to this function
     */

  }, {
    key: "publishMultiparts",
    value: function () {
      var _publishMultiparts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
        var mpx, mps, txids, _iterator, _step, mp, _yield$mp$signSelf, error, txid;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(typeof data !== 'string')) {
                  _context5.next = 2;
                  break;
                }

                throw new Error("Data must be of type string. Got: ".concat(typeof data));

              case 2:
                if (this.walletInitialized) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 5;
                return this.wallet.initialize();

              case 5:
                this.walletInitialized = true;

              case 6:
                mpx = new _modules.MultipartX(data);
                mps = mpx.getMultiparts();
                txids = [];
                _iterator = _createForOfIteratorHelper(mps);
                _context5.prev = 10;

                _iterator.s();

              case 12:
                if ((_step = _iterator.n()).done) {
                  _context5.next = 39;
                  break;
                }

                mp = _step.value;
                // set reference, addr, and sign
                mp.setAddress(this.options.publicAddress);

                if (txids.length > 0) {
                  mp.setReference(txids[0]);
                }

                _context5.next = 18;
                return mp.signSelf(this.wallet.signMessage.bind(this.wallet));

              case 18:
                _yield$mp$signSelf = _context5.sent;
                error = _yield$mp$signSelf.error;

                if (!error) {
                  _context5.next = 22;
                  break;
                }

                throw new Error("Failed to sign multipart: ".concat(error));

              case 22:
                if (mp.isValid().success) {
                  _context5.next = 25;
                  break;
                }

                console.log(mp);
                throw new Error("Invalid multipart: ".concat(mp.isValid().error));

              case 25:
                txid = void 0;
                _context5.prev = 26;
                _context5.next = 29;
                return this.wallet.sendDataToChain(mp.toString());

              case 29:
                txid = _context5.sent;
                _context5.next = 36;
                break;

              case 32:
                _context5.prev = 32;
                _context5.t0 = _context5["catch"](26);
                console.log(_context5.t0.stack);
                throw new Error("Failed to broadcast multipart: ".concat(_context5.t0));

              case 36:
                // console.log(txid)
                txids.push(txid);

              case 37:
                _context5.next = 12;
                break;

              case 39:
                _context5.next = 44;
                break;

              case 41:
                _context5.prev = 41;
                _context5.t1 = _context5["catch"](10);

                _iterator.e(_context5.t1);

              case 44:
                _context5.prev = 44;

                _iterator.f();

                return _context5.finish(44);

              case 47:
                return _context5.abrupt("return", txids);

              case 48:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[10, 41, 44, 47], [26, 32]]);
      }));

      function publishMultiparts(_x6) {
        return _publishMultiparts.apply(this, arguments);
      }

      return publishMultiparts;
    }()
  }]);

  return OIP;
}();

var _default = OIP;
exports.default = _default;